var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocxIcon = function SvgDocxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69103 10.9118C4.72527 11.181 4.74811 11.415 4.75857 11.6158H4.79851C4.81373 11.4255 4.84544 11.1962 4.89364 10.9279C4.94185 10.6597 4.9853 10.4329 5.02398 10.2477L6.85817 2.33446H9.22987L11.1326 10.1288C11.2431 10.6135 11.3222 11.1048 11.3694 11.5996H11.4008C11.4363 11.1202 11.5024 10.6435 11.5987 10.1726L13.1161 2.33066H15.2747L12.609 13.6707H10.087L8.27949 6.16075C8.22717 5.9448 8.16724 5.66225 8.10159 5.315C8.03595 4.96776 7.99504 4.71375 7.97887 4.55393H7.94747C7.92655 4.73848 7.88562 5.01249 7.82474 5.37589C7.76385 5.73931 7.71501 6.00821 7.67822 6.18263L5.97911 13.6687H3.41429L0.734375 2.33444H2.93197L4.58445 10.2639C4.62157 10.4266 4.65678 10.6435 4.69103 10.9118Z",
    fill: "url(#paint0_linear_9535_23919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9535_23919",
    x1: 253.329,
    y1: 179.552,
    x2: 962.06,
    y2: 1136.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
};
export { SvgDocxIcon as ReactComponent };
export default __webpack_public_path__ + "docx-icon.svg";